<template>
    <svg id="Camada_1" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 180.93 126.3">
        <path
            fill="#84cc16"
            d="M59.55,126.3c-1.26,0-2.52-.48-3.48-1.44L1.44,70.22c-1.92-1.92-1.92-5.03,0-6.95,1.92-1.92,5.03-1.92,6.95,0l51.16,51.16L172.54,1.44c1.92-1.92,5.03-1.92,6.95,0,1.92,1.92,1.92,5.03,0,6.95L63.03,124.86c-.96,.96-2.22,1.44-3.48,1.44Z" />
    </svg>
</template>

<script setup>

</script>

<style>

</style>
